<div class="help wrapper" *ngIf="menu && menu.MenuItems.length > 0">
    <div class="row">
        <ul class="column small-12">

            <li *ngIf="menu.MetaData.IsDumpSessionShown"><a href="/dumpsession">Dump Session</a></li>
            <li *ngIf="allowContentfulEditing"><a title="Contentful editing"><div class="contentfulEditing" [ngClass]="{ 'enabled': contentfulEditMode }" (click)="toggleContentfulEditing()"></div></a></li>
            <li *ngIf="menu.MetaData.IsAgent">
                <span>{{menu.MetaData.LoginName}} | {{menu.MetaData.Company}} | {{menu.MetaData.AccountNumber}}{{menu.MetaData.AgentReference ? " | " + menu.MetaData.AgentReference : "" }}</span>
            </li>

            <li *ngFor="let item of menu.MenuItems">
                <a *ngIf="item.Title && item.Href" id="href" [ngClass]="getClasses(item)" [attr.href]="item.Href" [attr.target]="getTarget(item)">{{item.Title}}</a>
                <a *ngIf="item.Title && !item.Href" id="routerlink" [ngClass]="getClasses(item)" [routerLink]="item.Route" [attr.target]="getTarget(item)">{{item.Title}}</a>
            </li>
        </ul>
    </div>
</div>
<div class="help wrapper" *ngIf="!(menu && menu.MenuItems.length > 0)">
    <!-- Insert some elements to reduce jumping while loading. These will in most cases have same height as real content -->
    <div class="row">
        <ul class="column small-12">
            <li><a class="dummy-loading">&nbsp;</a></li>
            <li><a class="dummy-loading">&nbsp;</a></li>
            <li><a class="dummy-loading">&nbsp;</a></li>
            <li><a class="dummy-loading">&nbsp;</a></li>
        </ul>
    </div>
</div>
